import { IDominioResponseQA } from "src/app/shared/interfaces/dados-pessoais/dominio-qa-response.interface";

export const LISTA_NACIONALIDADE: IDominioResponseQA =
{
  "codigo_dominio": 24,
  "nome_dominio": "DENOMINACAO NACIONALIDADE",
  "descricao_conceito_dominio": "DENOMINACAO DAS NACIONALIDADES, DESCRITO EM UM IDIOMA (EXEMPLO: BRASILEIRO, BRAZILIAN)",
  "nome_referencia_dominio": "COD_NACL",
  "headers": null,
  "valores_dominio": [
    {
      "codigo_valor_dominio": 619,
      "codigo_referencia_valor_dominio": "AF",
      "nome_resumido_valor_dominio": "AFEGA",
      "nome_completo_valor_dominio": "AFEGA",
      "descricao_conceito_valor_dominio": "AFEGA AF"
    },
    {
      "codigo_valor_dominio": 620,
      "codigo_referencia_valor_dominio": "AL",
      "nome_resumido_valor_dominio": "ALBANESA",
      "nome_completo_valor_dominio": "ALBANESA",
      "descricao_conceito_valor_dominio": "ALBANESA AL"
    },
    {
      "codigo_valor_dominio": 621,
      "codigo_referencia_valor_dominio": "DE",
      "nome_resumido_valor_dominio": "ALEMA",
      "nome_completo_valor_dominio": "ALEMA",
      "descricao_conceito_valor_dominio": "ALEMA DE"
    },
    {
      "codigo_valor_dominio": 622,
      "codigo_referencia_valor_dominio": "AD",
      "nome_resumido_valor_dominio": "ANDORRENSE",
      "nome_completo_valor_dominio": "ANDORRENSE",
      "descricao_conceito_valor_dominio": "ANDORRENSE AD"
    },
    {
      "codigo_valor_dominio": 623,
      "codigo_referencia_valor_dominio": "AO",
      "nome_resumido_valor_dominio": "ANGOLANA",
      "nome_completo_valor_dominio": "ANGOLANA",
      "descricao_conceito_valor_dominio": "ANGOLANA AO"
    },
    {
      "codigo_valor_dominio": 624,
      "codigo_referencia_valor_dominio": "AI",
      "nome_resumido_valor_dominio": "ANGUILANA",
      "nome_completo_valor_dominio": "ANGUILANA",
      "descricao_conceito_valor_dominio": "ANGUILANA AI"
    },
    {
      "codigo_valor_dominio": 625,
      "codigo_referencia_valor_dominio": "AG",
      "nome_resumido_valor_dominio": "ANTIGUANA",
      "nome_completo_valor_dominio": "ANTIGUANA",
      "descricao_conceito_valor_dominio": "ANTIGUANA AG"
    },
    {
      "codigo_valor_dominio": 627,
      "codigo_referencia_valor_dominio": "DZ",
      "nome_resumido_valor_dominio": "ARGELIANA",
      "nome_completo_valor_dominio": "ARGELIANA",
      "descricao_conceito_valor_dominio": "ARGELIANA DZ"
    },
    {
      "codigo_valor_dominio": 628,
      "codigo_referencia_valor_dominio": "AR",
      "nome_resumido_valor_dominio": "ARGENTINA",
      "nome_completo_valor_dominio": "ARGENTINA",
      "descricao_conceito_valor_dominio": "ARGENTINA AR"
    },
    {
      "codigo_valor_dominio": 629,
      "codigo_referencia_valor_dominio": "AM",
      "nome_resumido_valor_dominio": "ARMENA",
      "nome_completo_valor_dominio": "ARMENA",
      "descricao_conceito_valor_dominio": "ARMENA AM"
    },
    {
      "codigo_valor_dominio": 630,
      "codigo_referencia_valor_dominio": "AW",
      "nome_resumido_valor_dominio": "ARUBENHA",
      "nome_completo_valor_dominio": "ARUBENHA",
      "descricao_conceito_valor_dominio": "ARUBENHA AW"
    },
    {
      "codigo_valor_dominio": 631,
      "codigo_referencia_valor_dominio": "AU",
      "nome_resumido_valor_dominio": "AUSTRALIANA (AU)",
      "nome_completo_valor_dominio": "AUSTRALIANA (AUSTRALIA)",
      "descricao_conceito_valor_dominio": "AUSTRALIANA (AUSTRALIA) AU"
    },
    {
      "codigo_valor_dominio": 632,
      "codigo_referencia_valor_dominio": "CC",
      "nome_resumido_valor_dominio": "AUSTRALIANA (CC)",
      "nome_completo_valor_dominio": "AUSTRALIANA (ILHAS COCOS)",
      "descricao_conceito_valor_dominio": "AUSTRALIANA (ILHAS COCOS) CC"
    },
    {
      "codigo_valor_dominio": 633,
      "codigo_referencia_valor_dominio": "NF",
      "nome_resumido_valor_dominio": "AUSTRALIANA (NF)",
      "nome_completo_valor_dominio": "AUSTRALIANA (ILHA NORFOLK)",
      "descricao_conceito_valor_dominio": "AUSTRALIANA (ILHA NORFOLK) NF"
    },
    {
      "codigo_valor_dominio": 634,
      "codigo_referencia_valor_dominio": "AT",
      "nome_resumido_valor_dominio": "AUSTRIACA",
      "nome_completo_valor_dominio": "AUSTRIACA",
      "descricao_conceito_valor_dominio": "AUSTRIACA AT"
    },
    {
      "codigo_valor_dominio": 635,
      "codigo_referencia_valor_dominio": "AZ",
      "nome_resumido_valor_dominio": "AZERBAIDJANA",
      "nome_completo_valor_dominio": "AZERBAIDJANA",
      "descricao_conceito_valor_dominio": "AZERBAIDJANA AZ"
    },
    {
      "codigo_valor_dominio": 636,
      "codigo_referencia_valor_dominio": "BH",
      "nome_resumido_valor_dominio": "BARAINITA",
      "nome_completo_valor_dominio": "BARAINITA",
      "descricao_conceito_valor_dominio": "BARAINITA BH"
    },
    {
      "codigo_valor_dominio": 637,
      "codigo_referencia_valor_dominio": "BS",
      "nome_resumido_valor_dominio": "BARAMENHA",
      "nome_completo_valor_dominio": "BARAMENHA",
      "descricao_conceito_valor_dominio": "BARAMENHA BS"
    },
    {
      "codigo_valor_dominio": 638,
      "codigo_referencia_valor_dominio": "BB",
      "nome_resumido_valor_dominio": "BARBADIANA",
      "nome_completo_valor_dominio": "BARBADIANA",
      "descricao_conceito_valor_dominio": "BARBADIANA BB"
    },
    {
      "codigo_valor_dominio": 639,
      "codigo_referencia_valor_dominio": "BE",
      "nome_resumido_valor_dominio": "BELGA",
      "nome_completo_valor_dominio": "BELGA",
      "descricao_conceito_valor_dominio": "BELGA BE"
    },
    {
      "codigo_valor_dominio": 640,
      "codigo_referencia_valor_dominio": "BZ",
      "nome_resumido_valor_dominio": "BELIZENHA",
      "nome_completo_valor_dominio": "BELIZENHA",
      "descricao_conceito_valor_dominio": "BELIZENHA BZ"
    },
    {
      "codigo_valor_dominio": 641,
      "codigo_referencia_valor_dominio": "BD",
      "nome_resumido_valor_dominio": "BENGALENSE",
      "nome_completo_valor_dominio": "BENGALENSE",
      "descricao_conceito_valor_dominio": "BENGALENSE BD"
    },
    {
      "codigo_valor_dominio": 642,
      "codigo_referencia_valor_dominio": "BJ",
      "nome_resumido_valor_dominio": "BENINEMSE",
      "nome_completo_valor_dominio": "BENINEMSE",
      "descricao_conceito_valor_dominio": "BENINEMSE BJ"
    },
    {
      "codigo_valor_dominio": 643,
      "codigo_referencia_valor_dominio": "BY",
      "nome_resumido_valor_dominio": "BIELO-RUSSA",
      "nome_completo_valor_dominio": "BIELO-RUSSA",
      "descricao_conceito_valor_dominio": "BIELO-RUSSA BY"
    },
    {
      "codigo_valor_dominio": 644,
      "codigo_referencia_valor_dominio": "MM",
      "nome_resumido_valor_dominio": "BIRMANESA",
      "nome_completo_valor_dominio": "BIRMANESA",
      "descricao_conceito_valor_dominio": "BIRMANESA MM"
    },
    {
      "codigo_valor_dominio": 645,
      "codigo_referencia_valor_dominio": "BO",
      "nome_resumido_valor_dominio": "BOLIVIANA",
      "nome_completo_valor_dominio": "BOLIVIANA",
      "descricao_conceito_valor_dominio": "BOLIVIANA BO"
    },
    {
      "codigo_valor_dominio": 646,
      "codigo_referencia_valor_dominio": "BA",
      "nome_resumido_valor_dominio": "BOSNIA",
      "nome_completo_valor_dominio": "BOSNIA",
      "descricao_conceito_valor_dominio": "BOSNIA BA"
    },
    {
      "codigo_valor_dominio": 647,
      "codigo_referencia_valor_dominio": "BW",
      "nome_resumido_valor_dominio": "BOTSWANESA",
      "nome_completo_valor_dominio": "BOTSWANESA",
      "descricao_conceito_valor_dominio": "BOTSWANESA BW"
    },
    {
      "codigo_valor_dominio": 648,
      "codigo_referencia_valor_dominio": "BR",
      "nome_resumido_valor_dominio": "BRASILEIRA",
      "nome_completo_valor_dominio": "BRASILEIRA",
      "descricao_conceito_valor_dominio": "BRASILEIRA BR"
    },
    {
      "codigo_valor_dominio": 649,
      "codigo_referencia_valor_dominio": "BM",
      "nome_resumido_valor_dominio": "BRITANICA (BM)",
      "nome_completo_valor_dominio": "BRITANICA (BERMUDA)",
      "descricao_conceito_valor_dominio": "BRITANICA (BERMUDA) BM"
    },
    {
      "codigo_valor_dominio": 650,
      "codigo_referencia_valor_dominio": "GB",
      "nome_resumido_valor_dominio": "BRITANICA (GB)",
      "nome_completo_valor_dominio": "BRITANICA (GRA-BRETANHA)",
      "descricao_conceito_valor_dominio": "BRITANICA (GRA-BRETANHA) GB"
    },
    {
      "codigo_valor_dominio": 651,
      "codigo_referencia_valor_dominio": "IO",
      "nome_resumido_valor_dominio": "BRITANICA (IO)",
      "nome_completo_valor_dominio": "BRITANICA (BRITISH INDIAN OCEAN TERRITORY)",
      "descricao_conceito_valor_dominio": "BRITANICA (BRITISH INDIAN OCEAN TERRITORY) IO"
    },
    {
      "codigo_valor_dominio": 652,
      "codigo_referencia_valor_dominio": "KN",
      "nome_resumido_valor_dominio": "BRITANICA (KN)",
      "nome_completo_valor_dominio": "BRITANICA (SAO CRISTOVAO E NEVIS)",
      "descricao_conceito_valor_dominio": "BRITANICA (SAO CRISTOVAO E NEVIS) KN"
    },
    {
      "codigo_valor_dominio": 653,
      "codigo_referencia_valor_dominio": "MS",
      "nome_resumido_valor_dominio": "BRITANICA (MS)",
      "nome_completo_valor_dominio": "BRITANICA (MONTSERRAT)",
      "descricao_conceito_valor_dominio": "BRITANICA (MONTSERRAT) MS"
    },
    {
      "codigo_valor_dominio": 654,
      "codigo_referencia_valor_dominio": "NU",
      "nome_resumido_valor_dominio": "BRITANICA (NU)",
      "nome_completo_valor_dominio": "BRITANICA (NIUE)",
      "descricao_conceito_valor_dominio": "BRITANICA (NIUE) NU"
    },
    {
      "codigo_valor_dominio": 655,
      "codigo_referencia_valor_dominio": "SH",
      "nome_resumido_valor_dominio": "BRITANICA (SH)",
      "nome_completo_valor_dominio": "BRITANICA (ILHAS SANTA HELENA)",
      "descricao_conceito_valor_dominio": "BRITANICA (ILHAS SANTA HELENA) SH"
    },
    {
      "codigo_valor_dominio": 656,
      "codigo_referencia_valor_dominio": "TC",
      "nome_resumido_valor_dominio": "BRITANICA (TC)",
      "nome_completo_valor_dominio": "BRITANICA (ILHAS TURKS E CAICOS)",
      "descricao_conceito_valor_dominio": "BRITANICA (ILHAS TURKS E CAICOS) TC"
    },
    {
      "codigo_valor_dominio": 657,
      "codigo_referencia_valor_dominio": "HK",
      "nome_resumido_valor_dominio": "BRITANICA / CHINESA (HK)",
      "nome_completo_valor_dominio": "BRITANICA / CHINESA (HONG KONG)",
      "descricao_conceito_valor_dominio": "BRITANICA / CHINESA (HONG KONG) HK"
    },
    {
      "codigo_valor_dominio": 658,
      "codigo_referencia_valor_dominio": "BN",
      "nome_resumido_valor_dominio": "BRUNEIANA",
      "nome_completo_valor_dominio": "BRUNEIANA",
      "descricao_conceito_valor_dominio": "BRUNEIANA BN"
    },
    {
      "codigo_valor_dominio": 659,
      "codigo_referencia_valor_dominio": "BG",
      "nome_resumido_valor_dominio": "BULGARA",
      "nome_completo_valor_dominio": "BULGARA",
      "descricao_conceito_valor_dominio": "BULGARA BG"
    },
    {
      "codigo_valor_dominio": 660,
      "codigo_referencia_valor_dominio": "BF",
      "nome_resumido_valor_dominio": "BURQUINA",
      "nome_completo_valor_dominio": "BURQUINA",
      "descricao_conceito_valor_dominio": "BURQUINA BF"
    },
    {
      "codigo_valor_dominio": 661,
      "codigo_referencia_valor_dominio": "BI",
      "nome_resumido_valor_dominio": "BURUNDIANA",
      "nome_completo_valor_dominio": "BURUNDIANA",
      "descricao_conceito_valor_dominio": "BURUNDIANA BI"
    },
    {
      "codigo_valor_dominio": 662,
      "codigo_referencia_valor_dominio": "BT",
      "nome_resumido_valor_dominio": "BUTANESA",
      "nome_completo_valor_dominio": "BUTANESA",
      "descricao_conceito_valor_dominio": "BUTANESA BT"
    },
    {
      "codigo_valor_dominio": 663,
      "codigo_referencia_valor_dominio": "CV",
      "nome_resumido_valor_dominio": "CABO-VERDINA",
      "nome_completo_valor_dominio": "CABO-VERDINA",
      "descricao_conceito_valor_dominio": "CABO-VERDINA CV"
    },
    {
      "codigo_valor_dominio": 664,
      "codigo_referencia_valor_dominio": "KY",
      "nome_resumido_valor_dominio": "CAIMENSE",
      "nome_completo_valor_dominio": "CAIMENSE",
      "descricao_conceito_valor_dominio": "CAIMENSE KY"
    },
    {
      "codigo_valor_dominio": 665,
      "codigo_referencia_valor_dominio": "CM",
      "nome_resumido_valor_dominio": "CAMARONESA",
      "nome_completo_valor_dominio": "CAMARONESA",
      "descricao_conceito_valor_dominio": "CAMARONESA CM"
    },
    {
      "codigo_valor_dominio": 666,
      "codigo_referencia_valor_dominio": "KH",
      "nome_resumido_valor_dominio": "CAMBOJANA",
      "nome_completo_valor_dominio": "CAMBOJANA",
      "descricao_conceito_valor_dominio": "CAMBOJANA KH"
    },
    {
      "codigo_valor_dominio": 667,
      "codigo_referencia_valor_dominio": "CA",
      "nome_resumido_valor_dominio": "CANADENSE",
      "nome_completo_valor_dominio": "CANADENSE",
      "descricao_conceito_valor_dominio": "CANADENSE CA"
    },
    {
      "codigo_valor_dominio": 668,
      "codigo_referencia_valor_dominio": "QA",
      "nome_resumido_valor_dominio": "CATARIANA",
      "nome_completo_valor_dominio": "CATARIANA",
      "descricao_conceito_valor_dominio": "CATARIANA QA"
    },
    {
      "codigo_valor_dominio": 669,
      "codigo_referencia_valor_dominio": "KZ",
      "nome_resumido_valor_dominio": "CAZAQUE",
      "nome_completo_valor_dominio": "CAZAQUE",
      "descricao_conceito_valor_dominio": "CAZAQUE KZ"
    },
    {
      "codigo_valor_dominio": 670,
      "codigo_referencia_valor_dominio": "CF",
      "nome_resumido_valor_dominio": "CENTRO-AFRICANA",
      "nome_completo_valor_dominio": "CENTRO-AFRICANA",
      "descricao_conceito_valor_dominio": "CENTRO-AFRICANA CF"
    },
    {
      "codigo_valor_dominio": 671,
      "codigo_referencia_valor_dominio": "TD",
      "nome_resumido_valor_dominio": "CHADIANA",
      "nome_completo_valor_dominio": "CHADIANA",
      "descricao_conceito_valor_dominio": "CHADIANA TD"
    },
    {
      "codigo_valor_dominio": 672,
      "codigo_referencia_valor_dominio": "CL",
      "nome_resumido_valor_dominio": "CHILENA",
      "nome_completo_valor_dominio": "CHILENA",
      "descricao_conceito_valor_dominio": "CHILENA CL"
    },
    {
      "codigo_valor_dominio": 673,
      "codigo_referencia_valor_dominio": "CN",
      "nome_resumido_valor_dominio": "CHINESA",
      "nome_completo_valor_dominio": "CHINESA",
      "descricao_conceito_valor_dominio": "CHINESA CN"
    },
    {
      "codigo_valor_dominio": 674,
      "codigo_referencia_valor_dominio": "CY",
      "nome_resumido_valor_dominio": "CHIPRIANA",
      "nome_completo_valor_dominio": "CHIPRIANA",
      "descricao_conceito_valor_dominio": "CHIPRIANA CY"
    },
    {
      "codigo_valor_dominio": 675,
      "codigo_referencia_valor_dominio": "LK",
      "nome_resumido_valor_dominio": "CINGALESA",
      "nome_completo_valor_dominio": "CINGALESA",
      "descricao_conceito_valor_dominio": "CINGALESA LK"
    },
    {
      "codigo_valor_dominio": 676,
      "codigo_referencia_valor_dominio": "SG",
      "nome_resumido_valor_dominio": "CINGAPURIANA",
      "nome_completo_valor_dominio": "CINGAPURIANA",
      "descricao_conceito_valor_dominio": "CINGAPURIANA SG"
    },
    {
      "codigo_valor_dominio": 677,
      "codigo_referencia_valor_dominio": "CO",
      "nome_resumido_valor_dominio": "COLOMBIANA",
      "nome_completo_valor_dominio": "COLOMBIANA",
      "descricao_conceito_valor_dominio": "COLOMBIANA CO"
    },
    {
      "codigo_valor_dominio": 678,
      "codigo_referencia_valor_dominio": "KM",
      "nome_resumido_valor_dominio": "COMORENSE",
      "nome_completo_valor_dominio": "COMORENSE",
      "descricao_conceito_valor_dominio": "COMORENSE KM"
    },
    {
      "codigo_valor_dominio": 679,
      "codigo_referencia_valor_dominio": "ZR",
      "nome_resumido_valor_dominio": "CONGALESA",
      "nome_completo_valor_dominio": "CONGALESA",
      "descricao_conceito_valor_dominio": "CONGALESA ZR"
    },
    {
      "codigo_valor_dominio": 680,
      "codigo_referencia_valor_dominio": "CD",
      "nome_resumido_valor_dominio": "CONGONESA",
      "nome_completo_valor_dominio": "CONGONESA",
      "descricao_conceito_valor_dominio": "CONGONESA CD"
    },
    {
      "codigo_valor_dominio": 681,
      "codigo_referencia_valor_dominio": "CR",
      "nome_resumido_valor_dominio": "COSTA-REQUENSE",
      "nome_completo_valor_dominio": "COSTA-REQUENSE",
      "descricao_conceito_valor_dominio": "COSTA-REQUENSE CR"
    },
    {
      "codigo_valor_dominio": 682,
      "codigo_referencia_valor_dominio": "HR",
      "nome_resumido_valor_dominio": "CROATA",
      "nome_completo_valor_dominio": "CROATA",
      "descricao_conceito_valor_dominio": "CROATA HR"
    },
    {
      "codigo_valor_dominio": 683,
      "codigo_referencia_valor_dominio": "CU",
      "nome_resumido_valor_dominio": "CUBANA",
      "nome_completo_valor_dominio": "CUBANA",
      "descricao_conceito_valor_dominio": "CUBANA CU"
    },
    {
      "codigo_valor_dominio": 684,
      "codigo_referencia_valor_dominio": "DK",
      "nome_resumido_valor_dominio": "DINAMARQUESA (DK)",
      "nome_completo_valor_dominio": "DINAMARQUESA (DINAMARCA)",
      "descricao_conceito_valor_dominio": "DINAMARQUESA (DINAMARCA) DK"
    },
    {
      "codigo_valor_dominio": 685,
      "codigo_referencia_valor_dominio": "FO",
      "nome_resumido_valor_dominio": "DINAMARQUESA (FO)",
      "nome_completo_valor_dominio": "DINAMARQUESA (ILHAS FAROE)",
      "descricao_conceito_valor_dominio": "DINAMARQUESA (ILHAS FAROE) FO"
    },
    {
      "codigo_valor_dominio": 686,
      "codigo_referencia_valor_dominio": "GL",
      "nome_resumido_valor_dominio": "DINAMARQUESA (GL)",
      "nome_completo_valor_dominio": "DINAMARQUESA (GROENLANDIA)",
      "descricao_conceito_valor_dominio": "DINAMARQUESA (GROENLANDIA) GL"
    },
    {
      "codigo_valor_dominio": 687,
      "codigo_referencia_valor_dominio": "DJ",
      "nome_resumido_valor_dominio": "DJIBUTIANA",
      "nome_completo_valor_dominio": "DJIBUTIANA",
      "descricao_conceito_valor_dominio": "DJIBUTIANA DJ"
    },
    {
      "codigo_valor_dominio": 688,
      "codigo_referencia_valor_dominio": "DM",
      "nome_resumido_valor_dominio": "DOMINICANA (DM)",
      "nome_completo_valor_dominio": "DOMINICANA (DOMINICA)",
      "descricao_conceito_valor_dominio": "DOMINICANA (DOMINICA) DM"
    },
    {
      "codigo_valor_dominio": 689,
      "codigo_referencia_valor_dominio": "DO",
      "nome_resumido_valor_dominio": "DOMINICANA (DO)",
      "nome_completo_valor_dominio": "DOMINICANA (REPUBLICA DOMINICANA)",
      "descricao_conceito_valor_dominio": "DOMINICANA (REPUBLICA DOMINICANA) DO"
    },
    {
      "codigo_valor_dominio": 690,
      "codigo_referencia_valor_dominio": "EG",
      "nome_resumido_valor_dominio": "EGIPCIA",
      "nome_completo_valor_dominio": "EGIPCIA",
      "descricao_conceito_valor_dominio": "EGIPCIA EG"
    },
    {
      "codigo_valor_dominio": 691,
      "codigo_referencia_valor_dominio": "AE",
      "nome_resumido_valor_dominio": "EMIRADENSE",
      "nome_completo_valor_dominio": "EMIRADENSE",
      "descricao_conceito_valor_dominio": "EMIRADENSE AE"
    },
    {
      "codigo_valor_dominio": 692,
      "codigo_referencia_valor_dominio": "EC",
      "nome_resumido_valor_dominio": "EQUATORIANA",
      "nome_completo_valor_dominio": "EQUATORIANA",
      "descricao_conceito_valor_dominio": "EQUATORIANA EC"
    },
    {
      "codigo_valor_dominio": 693,
      "codigo_referencia_valor_dominio": "ER",
      "nome_resumido_valor_dominio": "ERITREIA",
      "nome_completo_valor_dominio": "ERITREIA",
      "descricao_conceito_valor_dominio": "ERITREIA ER"
    },
    {
      "codigo_valor_dominio": 694,
      "codigo_referencia_valor_dominio": "SK",
      "nome_resumido_valor_dominio": "ESLOVACA",
      "nome_completo_valor_dominio": "ESLOVACA",
      "descricao_conceito_valor_dominio": "ESLOVACA SK"
    },
    {
      "codigo_valor_dominio": 695,
      "codigo_referencia_valor_dominio": "SI",
      "nome_resumido_valor_dominio": "ESLOVENIA",
      "nome_completo_valor_dominio": "ESLOVENIA",
      "descricao_conceito_valor_dominio": "ESLOVENIA SI"
    },
    {
      "codigo_valor_dominio": 696,
      "codigo_referencia_valor_dominio": "ES",
      "nome_resumido_valor_dominio": "ESPANHOLA",
      "nome_completo_valor_dominio": "ESPANHOLA",
      "descricao_conceito_valor_dominio": "ESPANHOLA ES"
    },
    {
      "codigo_valor_dominio": 697,
      "codigo_referencia_valor_dominio": "EE",
      "nome_resumido_valor_dominio": "ESTONIANA",
      "nome_completo_valor_dominio": "ESTONIANA",
      "descricao_conceito_valor_dominio": "ESTONIANA EE"
    },
    {
      "codigo_valor_dominio": 698,
      "codigo_referencia_valor_dominio": "ET",
      "nome_resumido_valor_dominio": "ETIOPE",
      "nome_completo_valor_dominio": "ETIOPE",
      "descricao_conceito_valor_dominio": "ETIOPE ET"
    },
    {
      "codigo_valor_dominio": 699,
      "codigo_referencia_valor_dominio": "FJ",
      "nome_resumido_valor_dominio": "FIGIANA",
      "nome_completo_valor_dominio": "FIGIANA",
      "descricao_conceito_valor_dominio": "FIGIANA FJ"
    },
    {
      "codigo_valor_dominio": 700,
      "codigo_referencia_valor_dominio": "PH",
      "nome_resumido_valor_dominio": "FILIPENHA",
      "nome_completo_valor_dominio": "FILIPENHA",
      "descricao_conceito_valor_dominio": "FILIPENHA PH"
    },
    {
      "codigo_valor_dominio": 701,
      "codigo_referencia_valor_dominio": "FI",
      "nome_resumido_valor_dominio": "FINLANDESA",
      "nome_completo_valor_dominio": "FINLANDESA",
      "descricao_conceito_valor_dominio": "FINLANDESA FI"
    },
    {
      "codigo_valor_dominio": 702,
      "codigo_referencia_valor_dominio": "FR",
      "nome_resumido_valor_dominio": "FRANCESA (FR)",
      "nome_completo_valor_dominio": "FRANCESA (FRANCA)",
      "descricao_conceito_valor_dominio": "FRANCESA (FRANCA) FR"
    },
    {
      "codigo_valor_dominio": 703,
      "codigo_referencia_valor_dominio": "GF",
      "nome_resumido_valor_dominio": "FRANCESA (GF)",
      "nome_completo_valor_dominio": "FRANCESA (GUIANA FRANCESA)",
      "descricao_conceito_valor_dominio": "FRANCESA (GUIANA FRANCESA) GF"
    },
    {
      "codigo_valor_dominio": 704,
      "codigo_referencia_valor_dominio": "GP",
      "nome_resumido_valor_dominio": "FRANCESA (GP)",
      "nome_completo_valor_dominio": "FRANCESA (GUADALUPE)",
      "descricao_conceito_valor_dominio": "FRANCESA (GUADALUPE) GP"
    },
    {
      "codigo_valor_dominio": 705,
      "codigo_referencia_valor_dominio": "MQ",
      "nome_resumido_valor_dominio": "FRANCESA (MQ)",
      "nome_completo_valor_dominio": "FRANCESA (MARTINICA)",
      "descricao_conceito_valor_dominio": "FRANCESA (MARTINICA) MQ"
    },
    {
      "codigo_valor_dominio": 706,
      "codigo_referencia_valor_dominio": "NC",
      "nome_resumido_valor_dominio": "FRANCESA (NC)",
      "nome_completo_valor_dominio": "FRANCESA (NOVA CALEDONIA)",
      "descricao_conceito_valor_dominio": "FRANCESA (NOVA CALEDONIA) NC"
    },
    {
      "codigo_valor_dominio": 707,
      "codigo_referencia_valor_dominio": "PM",
      "nome_resumido_valor_dominio": "FRANCESA (PM)",
      "nome_completo_valor_dominio": "FRANCESA (SAO PIERRE E MIQUELON)",
      "descricao_conceito_valor_dominio": "FRANCESA (SAO PIERRE E MIQUELON) PM"
    },
    {
      "codigo_valor_dominio": 708,
      "codigo_referencia_valor_dominio": "RE",
      "nome_resumido_valor_dominio": "FRANCESA (RE)",
      "nome_completo_valor_dominio": "FRANCESA (ILHAS REUNIAO)",
      "descricao_conceito_valor_dominio": "FRANCESA (ILHAS REUNIAO) RE"
    },
    {
      "codigo_valor_dominio": 709,
      "codigo_referencia_valor_dominio": "GA",
      "nome_resumido_valor_dominio": "GABANESA",
      "nome_completo_valor_dominio": "GABANESA",
      "descricao_conceito_valor_dominio": "GABANESA GA"
    },
    {
      "codigo_valor_dominio": 710,
      "codigo_referencia_valor_dominio": "GM",
      "nome_resumido_valor_dominio": "GANBIANA",
      "nome_completo_valor_dominio": "GANBIANA",
      "descricao_conceito_valor_dominio": "GANBIANA GM"
    },
    {
      "codigo_valor_dominio": 711,
      "codigo_referencia_valor_dominio": "GH",
      "nome_resumido_valor_dominio": "GANENSE",
      "nome_completo_valor_dominio": "GANENSE",
      "descricao_conceito_valor_dominio": "GANENSE GH"
    },
    {
      "codigo_valor_dominio": 712,
      "codigo_referencia_valor_dominio": "GE",
      "nome_resumido_valor_dominio": "GEORGIANA",
      "nome_completo_valor_dominio": "GEORGIANA",
      "descricao_conceito_valor_dominio": "GEORGIANA GE"
    },
    {
      "codigo_valor_dominio": 713,
      "codigo_referencia_valor_dominio": "GI",
      "nome_resumido_valor_dominio": "GIBRALTARINA",
      "nome_completo_valor_dominio": "GIBRALTARINA",
      "descricao_conceito_valor_dominio": "GIBRALTARINA GI"
    },
    {
      "codigo_valor_dominio": 714,
      "codigo_referencia_valor_dominio": "CG",
      "nome_resumido_valor_dominio": "GONGALESA",
      "nome_completo_valor_dominio": "GONGALESA",
      "descricao_conceito_valor_dominio": "GONGALESA CG"
    },
    {
      "codigo_valor_dominio": 715,
      "codigo_referencia_valor_dominio": "GD",
      "nome_resumido_valor_dominio": "GRANADINA",
      "nome_completo_valor_dominio": "GRANADINA",
      "descricao_conceito_valor_dominio": "GRANADINA GD"
    },
    {
      "codigo_valor_dominio": 716,
      "codigo_referencia_valor_dominio": "GR",
      "nome_resumido_valor_dominio": "GREGA",
      "nome_completo_valor_dominio": "GREGA",
      "descricao_conceito_valor_dominio": "GREGA GR"
    },
    {
      "codigo_valor_dominio": 717,
      "codigo_referencia_valor_dominio": "GT",
      "nome_resumido_valor_dominio": "GUATEMALTECA",
      "nome_completo_valor_dominio": "GUATEMALTECA",
      "descricao_conceito_valor_dominio": "GUATEMALTECA GT"
    },
    {
      "codigo_valor_dominio": 718,
      "codigo_referencia_valor_dominio": "GY",
      "nome_resumido_valor_dominio": "GUIANESA",
      "nome_completo_valor_dominio": "GUIANESA",
      "descricao_conceito_valor_dominio": "GUIANESA GY"
    },
    {
      "codigo_valor_dominio": 719,
      "codigo_referencia_valor_dominio": "GQ",
      "nome_resumido_valor_dominio": "GUINE-EQUATORIANA",
      "nome_completo_valor_dominio": "GUINE-EQUATORIANA",
      "descricao_conceito_valor_dominio": "GUINE-EQUATORIANA GQ"
    },
    {
      "codigo_valor_dominio": 720,
      "codigo_referencia_valor_dominio": "GN",
      "nome_resumido_valor_dominio": "GUINEANA",
      "nome_completo_valor_dominio": "GUINEANA",
      "descricao_conceito_valor_dominio": "GUINEANA GN"
    },
    {
      "codigo_valor_dominio": 721,
      "codigo_referencia_valor_dominio": "GW",
      "nome_resumido_valor_dominio": "GUINEENSE",
      "nome_completo_valor_dominio": "GUINEENSE",
      "descricao_conceito_valor_dominio": "GUINEENSE GW"
    },
    {
      "codigo_valor_dominio": 722,
      "codigo_referencia_valor_dominio": "HT",
      "nome_resumido_valor_dominio": "HAITIANA",
      "nome_completo_valor_dominio": "HAITIANA",
      "descricao_conceito_valor_dominio": "HAITIANA HT"
    },
    {
      "codigo_valor_dominio": 723,
      "codigo_referencia_valor_dominio": "NL",
      "nome_resumido_valor_dominio": "HOLANDESA",
      "nome_completo_valor_dominio": "HOLANDESA",
      "descricao_conceito_valor_dominio": "HOLANDESA NL"
    },
    {
      "codigo_valor_dominio": 724,
      "codigo_referencia_valor_dominio": "HN",
      "nome_resumido_valor_dominio": "HONDURENHA",
      "nome_completo_valor_dominio": "HONDURENHA",
      "descricao_conceito_valor_dominio": "HONDURENHA HN"
    },
    {
      "codigo_valor_dominio": 725,
      "codigo_referencia_valor_dominio": "HU",
      "nome_resumido_valor_dominio": "HUNGARA",
      "nome_completo_valor_dominio": "HUNGARA",
      "descricao_conceito_valor_dominio": "HUNGARA HU"
    },
    {
      "codigo_valor_dominio": 726,
      "codigo_referencia_valor_dominio": "YE",
      "nome_resumido_valor_dominio": "IEMENITA",
      "nome_completo_valor_dominio": "IEMENITA",
      "descricao_conceito_valor_dominio": "IEMENITA YE"
    },
    {
      "codigo_valor_dominio": 727,
      "codigo_referencia_valor_dominio": "IN",
      "nome_resumido_valor_dominio": "INDIANA",
      "nome_completo_valor_dominio": "INDIANA",
      "descricao_conceito_valor_dominio": "INDIANA IN"
    },
    {
      "codigo_valor_dominio": 728,
      "codigo_referencia_valor_dominio": "\"ID\"",
      "nome_resumido_valor_dominio": "INDONESIA",
      "nome_completo_valor_dominio": "INDONESIA",
      "descricao_conceito_valor_dominio": "INDONESIA ID"
    },
    {
      "codigo_valor_dominio": 729,
      "codigo_referencia_valor_dominio": "CX",
      "nome_resumido_valor_dominio": "INGLESA (CX)",
      "nome_completo_valor_dominio": "INGLESA (ILHA CHRISTMAS)",
      "descricao_conceito_valor_dominio": "INGLESA (ILHA CHRISTMAS) CX"
    },
    {
      "codigo_valor_dominio": 730,
      "codigo_referencia_valor_dominio": "FK",
      "nome_resumido_valor_dominio": "INGLESA (FK)",
      "nome_completo_valor_dominio": "INGLESA (ILHAS MALVINAS)",
      "descricao_conceito_valor_dominio": "INGLESA (ILHAS MALVINAS) FK"
    },
    {
      "codigo_valor_dominio": 731,
      "codigo_referencia_valor_dominio": "UK",
      "nome_resumido_valor_dominio": "INGLESA (GB)",
      "nome_completo_valor_dominio": "INGLESA (GRA-BRETANHA)",
      "descricao_conceito_valor_dominio": "INGLESA (GRA-BRETANHA) UK"
    },
    {
      "codigo_valor_dominio": 732,
      "codigo_referencia_valor_dominio": "VG",
      "nome_resumido_valor_dominio": "INGLESA (VG)",
      "nome_completo_valor_dominio": "INGLESA (ILHAS VIRGENS BRITANICAS)",
      "descricao_conceito_valor_dominio": "INGLESA (ILHAS VIRGENS BRITANICAS) VG"
    },
    {
      "codigo_valor_dominio": 733,
      "codigo_referencia_valor_dominio": "IR",
      "nome_resumido_valor_dominio": "IRANIANA",
      "nome_completo_valor_dominio": "IRANIANA",
      "descricao_conceito_valor_dominio": "IRANIANA IR"
    },
    {
      "codigo_valor_dominio": 734,
      "codigo_referencia_valor_dominio": "IQ",
      "nome_resumido_valor_dominio": "IRAQUIANA",
      "nome_completo_valor_dominio": "IRAQUIANA",
      "descricao_conceito_valor_dominio": "IRAQUIANA IQ"
    },
    {
      "codigo_valor_dominio": 735,
      "codigo_referencia_valor_dominio": "IE",
      "nome_resumido_valor_dominio": "IRLANDESA",
      "nome_completo_valor_dominio": "IRLANDESA",
      "descricao_conceito_valor_dominio": "IRLANDESA IE"
    },
    {
      "codigo_valor_dominio": 736,
      "codigo_referencia_valor_dominio": "IS",
      "nome_resumido_valor_dominio": "ISLANDESA",
      "nome_completo_valor_dominio": "ISLANDESA",
      "descricao_conceito_valor_dominio": "ISLANDESA IS"
    },
    {
      "codigo_valor_dominio": 737,
      "codigo_referencia_valor_dominio": "IL",
      "nome_resumido_valor_dominio": "ISRAELENSE",
      "nome_completo_valor_dominio": "ISRAELENSE",
      "descricao_conceito_valor_dominio": "ISRAELENSE IL"
    },
    {
      "codigo_valor_dominio": 738,
      "codigo_referencia_valor_dominio": "IT",
      "nome_resumido_valor_dominio": "ITALIANA",
      "nome_completo_valor_dominio": "ITALIANA",
      "descricao_conceito_valor_dominio": "ITALIANA IT"
    },
    {
      "codigo_valor_dominio": 739,
      "codigo_referencia_valor_dominio": "YU",
      "nome_resumido_valor_dominio": "IUGOSLAVA",
      "nome_completo_valor_dominio": "IUGOSLAVA",
      "descricao_conceito_valor_dominio": "IUGOSLAVA YU"
    },
    {
      "codigo_valor_dominio": 740,
      "codigo_referencia_valor_dominio": "JM",
      "nome_resumido_valor_dominio": "JAMAICANA",
      "nome_completo_valor_dominio": "JAMAICANA",
      "descricao_conceito_valor_dominio": "JAMAICANA JM"
    },
    {
      "codigo_valor_dominio": 741,
      "codigo_referencia_valor_dominio": "JP",
      "nome_resumido_valor_dominio": "JAPONESA",
      "nome_completo_valor_dominio": "JAPONESA",
      "descricao_conceito_valor_dominio": "JAPONESA JP"
    },
    {
      "codigo_valor_dominio": 742,
      "codigo_referencia_valor_dominio": "JO",
      "nome_resumido_valor_dominio": "JORDANIANA",
      "nome_completo_valor_dominio": "JORDANIANA",
      "descricao_conceito_valor_dominio": "JORDANIANA JO"
    },
    {
      "codigo_valor_dominio": 743,
      "codigo_referencia_valor_dominio": "KI",
      "nome_resumido_valor_dominio": "KIRIBATIANA",
      "nome_completo_valor_dominio": "KIRIBATIANA",
      "descricao_conceito_valor_dominio": "KIRIBATIANA KI"
    },
    {
      "codigo_valor_dominio": 744,
      "codigo_referencia_valor_dominio": "KW",
      "nome_resumido_valor_dominio": "KWAITIANA",
      "nome_completo_valor_dominio": "KWAITIANA",
      "descricao_conceito_valor_dominio": "KWAITIANA KW"
    },
    {
      "codigo_valor_dominio": 745,
      "codigo_referencia_valor_dominio": "LA",
      "nome_resumido_valor_dominio": "LAOCIANA",
      "nome_completo_valor_dominio": "LAOCIANA",
      "descricao_conceito_valor_dominio": "LAOCIANA LA"
    },
    {
      "codigo_valor_dominio": 746,
      "codigo_referencia_valor_dominio": "LS",
      "nome_resumido_valor_dominio": "LESOTANA",
      "nome_completo_valor_dominio": "LESOTANA",
      "descricao_conceito_valor_dominio": "LESOTANA LS"
    },
    {
      "codigo_valor_dominio": 747,
      "codigo_referencia_valor_dominio": "TP",
      "nome_resumido_valor_dominio": "LESTE-TIMORENSE (TP)",
      "nome_completo_valor_dominio": "LESTE-TIMORENSE (TP)",
      "descricao_conceito_valor_dominio": "LESTE-TIMORENSE (TP) TL"
    },
    {
      "codigo_valor_dominio": 749,
      "codigo_referencia_valor_dominio": "LV",
      "nome_resumido_valor_dominio": "LETA",
      "nome_completo_valor_dominio": "LETA",
      "descricao_conceito_valor_dominio": "LETA LV"
    },
    {
      "codigo_valor_dominio": 750,
      "codigo_referencia_valor_dominio": "LB",
      "nome_resumido_valor_dominio": "LIBANESA",
      "nome_completo_valor_dominio": "LIBANESA",
      "descricao_conceito_valor_dominio": "LIBANESA LB"
    },
    {
      "codigo_valor_dominio": 751,
      "codigo_referencia_valor_dominio": "LR",
      "nome_resumido_valor_dominio": "LIBERIANA",
      "nome_completo_valor_dominio": "LIBERIANA",
      "descricao_conceito_valor_dominio": "LIBERIANA LR"
    },
    {
      "codigo_valor_dominio": 752,
      "codigo_referencia_valor_dominio": "LY",
      "nome_resumido_valor_dominio": "LIBIA",
      "nome_completo_valor_dominio": "LIBIA",
      "descricao_conceito_valor_dominio": "LIBIA LY"
    },
    {
      "codigo_valor_dominio": 753,
      "codigo_referencia_valor_dominio": "LI",
      "nome_resumido_valor_dominio": "LIECHTENSTEINIANA",
      "nome_completo_valor_dominio": "LIECHTENSTEINIANA",
      "descricao_conceito_valor_dominio": "LIECHTENSTEINIANA LI"
    },
    {
      "codigo_valor_dominio": 754,
      "codigo_referencia_valor_dominio": "LT",
      "nome_resumido_valor_dominio": "LITUANICA",
      "nome_completo_valor_dominio": "LITUANICA",
      "descricao_conceito_valor_dominio": "LITUANICA LT"
    },
    {
      "codigo_valor_dominio": 755,
      "codigo_referencia_valor_dominio": "LU",
      "nome_resumido_valor_dominio": "LUXEMBURGUESA",
      "nome_completo_valor_dominio": "LUXEMBURGUESA",
      "descricao_conceito_valor_dominio": "LUXEMBURGUESA LU"
    },
    {
      "codigo_valor_dominio": 756,
      "codigo_referencia_valor_dominio": "MK",
      "nome_resumido_valor_dominio": "MACEDONICA",
      "nome_completo_valor_dominio": "MACEDONICA",
      "descricao_conceito_valor_dominio": "MACEDONICA MK"
    },
    {
      "codigo_valor_dominio": 757,
      "codigo_referencia_valor_dominio": "MG",
      "nome_resumido_valor_dominio": "MADAGASGARENA",
      "nome_completo_valor_dominio": "MADAGASGARENA",
      "descricao_conceito_valor_dominio": "MADAGASGARENA MG"
    },
    {
      "codigo_valor_dominio": 758,
      "codigo_referencia_valor_dominio": "MY",
      "nome_resumido_valor_dominio": "MALASIANA",
      "nome_completo_valor_dominio": "MALASIANA",
      "descricao_conceito_valor_dominio": "MALASIANA MY"
    },
    {
      "codigo_valor_dominio": 759,
      "codigo_referencia_valor_dominio": "MW",
      "nome_resumido_valor_dominio": "MALAWIANA",
      "nome_completo_valor_dominio": "MALAWIANA",
      "descricao_conceito_valor_dominio": "MALAWIANA MW"
    },
    {
      "codigo_valor_dominio": 760,
      "codigo_referencia_valor_dominio": "MV",
      "nome_resumido_valor_dominio": "MALDIVANA",
      "nome_completo_valor_dominio": "MALDIVANA",
      "descricao_conceito_valor_dominio": "MALDIVANA MV"
    },
    {
      "codigo_valor_dominio": 761,
      "codigo_referencia_valor_dominio": "ML",
      "nome_resumido_valor_dominio": "MALIESA",
      "nome_completo_valor_dominio": "MALIESA",
      "descricao_conceito_valor_dominio": "MALIESA ML"
    },
    {
      "codigo_valor_dominio": 762,
      "codigo_referencia_valor_dominio": "MT",
      "nome_resumido_valor_dominio": "MALTESA",
      "nome_completo_valor_dominio": "MALTESA",
      "descricao_conceito_valor_dominio": "MALTESA MT"
    },
    {
      "codigo_valor_dominio": 763,
      "codigo_referencia_valor_dominio": "CI",
      "nome_resumido_valor_dominio": "MARFINENSE",
      "nome_completo_valor_dominio": "MARFINENSE",
      "descricao_conceito_valor_dominio": "MARFINENSE CI"
    },
    {
      "codigo_valor_dominio": 764,
      "codigo_referencia_valor_dominio": "EH",
      "nome_resumido_valor_dominio": "MARROQUINA (EH)",
      "nome_completo_valor_dominio": "MARROQUINA (SAARA OCIDENTAL)",
      "descricao_conceito_valor_dominio": "MARROQUINA (SAARA OCIDENTAL)"
    },
    {
      "codigo_valor_dominio": 765,
      "codigo_referencia_valor_dominio": "MA",
      "nome_resumido_valor_dominio": "MARROQUINA",
      "nome_completo_valor_dominio": "MARROQUINA",
      "descricao_conceito_valor_dominio": "MARROQUINA MA"
    },
    {
      "codigo_valor_dominio": 766,
      "codigo_referencia_valor_dominio": "MH",
      "nome_resumido_valor_dominio": "MARSHALLINA",
      "nome_completo_valor_dominio": "MARSHALLINA",
      "descricao_conceito_valor_dominio": "MARSHALLINA MH"
    },
    {
      "codigo_valor_dominio": 767,
      "codigo_referencia_valor_dominio": "MU",
      "nome_resumido_valor_dominio": "MAURICIANA",
      "nome_completo_valor_dominio": "MAURICIANA",
      "descricao_conceito_valor_dominio": "MAURICIANA MU"
    },
    {
      "codigo_valor_dominio": 768,
      "codigo_referencia_valor_dominio": "MR",
      "nome_resumido_valor_dominio": "MAURITANIANA",
      "nome_completo_valor_dominio": "MAURITANIANA",
      "descricao_conceito_valor_dominio": "MAURITANIANA MR"
    },
    {
      "codigo_valor_dominio": 769,
      "codigo_referencia_valor_dominio": "MX",
      "nome_resumido_valor_dominio": "MEXICANA",
      "nome_completo_valor_dominio": "MEXICANA",
      "descricao_conceito_valor_dominio": "MEXICANA MX"
    },
    {
      "codigo_valor_dominio": 770,
      "codigo_referencia_valor_dominio": "FM",
      "nome_resumido_valor_dominio": "MICRONESIA",
      "nome_completo_valor_dominio": "MICRONESIA",
      "descricao_conceito_valor_dominio": "MICRONESIA FM"
    },
    {
      "codigo_valor_dominio": 771,
      "codigo_referencia_valor_dominio": "MZ",
      "nome_resumido_valor_dominio": "MOCAMBICANA",
      "nome_completo_valor_dominio": "MOCAMBICANA",
      "descricao_conceito_valor_dominio": "MOCAMBICANA MZ"
    },
    {
      "codigo_valor_dominio": 772,
      "codigo_referencia_valor_dominio": "MD",
      "nome_resumido_valor_dominio": "MOLDAVIA",
      "nome_completo_valor_dominio": "MOLDAVIA",
      "descricao_conceito_valor_dominio": "MOLDAVIA MD"
    },
    {
      "codigo_valor_dominio": 773,
      "codigo_referencia_valor_dominio": "MC",
      "nome_resumido_valor_dominio": "MONEGASCA",
      "nome_completo_valor_dominio": "MONEGASCA",
      "descricao_conceito_valor_dominio": "MONEGASCA MC"
    },
    {
      "codigo_valor_dominio": 774,
      "codigo_referencia_valor_dominio": "MN",
      "nome_resumido_valor_dominio": "MONGOLIANA",
      "nome_completo_valor_dominio": "MONGOLIANA",
      "descricao_conceito_valor_dominio": "MONGOLIANA MN"
    },
    {
      "codigo_valor_dominio": 775,
      "codigo_referencia_valor_dominio": "ME",
      "nome_resumido_valor_dominio": "MONTENEGRINA",
      "nome_completo_valor_dominio": "MONTENEGRINA",
      "descricao_conceito_valor_dominio": "MONTENEGRINA ME"
    },
    {
      "codigo_valor_dominio": 776,
      "codigo_referencia_valor_dominio": "NA",
      "nome_resumido_valor_dominio": "NAMBIANA",
      "nome_completo_valor_dominio": "NAMBIANA",
      "descricao_conceito_valor_dominio": "NAMBIANA NA"
    },
    {
      "codigo_valor_dominio": 777,
      "codigo_referencia_valor_dominio": "NR",
      "nome_resumido_valor_dominio": "NAURURUANA",
      "nome_completo_valor_dominio": "NAURURUANA",
      "descricao_conceito_valor_dominio": "NAURURUANA NR"
    },
    {
      "codigo_valor_dominio": 778,
      "codigo_referencia_valor_dominio": "CK",
      "nome_resumido_valor_dominio": "NEOZELANDESA (CK)",
      "nome_completo_valor_dominio": "NEOZELANDESA (ILHAS COOK)",
      "descricao_conceito_valor_dominio": "NEOZELANDESA (ILHAS COOK) CK"
    },
    {
      "codigo_valor_dominio": 779,
      "codigo_referencia_valor_dominio": "NZ",
      "nome_resumido_valor_dominio": "NEOZELANDESA (NZ)",
      "nome_completo_valor_dominio": "NEOZELANDESA (NOVA ZELANDIA)",
      "descricao_conceito_valor_dominio": "NEOZELANDESA (NOVA ZELANDIA) NZ"
    },
    {
      "codigo_valor_dominio": 780,
      "codigo_referencia_valor_dominio": "PN",
      "nome_resumido_valor_dominio": "NEOZELANDESA (PN)",
      "nome_completo_valor_dominio": "NEOZELANDESA (ILHAS PITCAIRN)",
      "descricao_conceito_valor_dominio": "NEOZELANDESA (ILHAS PITCAIRN) PN"
    },
    {
      "codigo_valor_dominio": 781,
      "codigo_referencia_valor_dominio": "TK",
      "nome_resumido_valor_dominio": "NEOZELANDESA (TK)",
      "nome_completo_valor_dominio": "NEOZELANDESA (ILHAS TOKELAU)",
      "descricao_conceito_valor_dominio": "NEOZELANDESA (ILHAS TOKELAU) TK"
    },
    {
      "codigo_valor_dominio": 782,
      "codigo_referencia_valor_dominio": "NP",
      "nome_resumido_valor_dominio": "NEPALESA",
      "nome_completo_valor_dominio": "NEPALESA",
      "descricao_conceito_valor_dominio": "NEPALESA NP"
    },
    {
      "codigo_valor_dominio": 783,
      "codigo_referencia_valor_dominio": "NI",
      "nome_resumido_valor_dominio": "NICARAGUENSE",
      "nome_completo_valor_dominio": "NICARAGUENSE",
      "descricao_conceito_valor_dominio": "NICARAGUENSE NI"
    },
    {
      "codigo_valor_dominio": 784,
      "codigo_referencia_valor_dominio": "NG",
      "nome_resumido_valor_dominio": "NIGERIANA",
      "nome_completo_valor_dominio": "NIGERIANA",
      "descricao_conceito_valor_dominio": "NIGERIANA NG"
    },
    {
      "codigo_valor_dominio": 785,
      "codigo_referencia_valor_dominio": "NE",
      "nome_resumido_valor_dominio": "NIGERINA",
      "nome_completo_valor_dominio": "NIGERINA",
      "descricao_conceito_valor_dominio": "NIGERINA NE"
    },
    {
      "codigo_valor_dominio": 786,
      "codigo_referencia_valor_dominio": "GU",
      "nome_resumido_valor_dominio": "NORTE-AMERICANA (GU)",
      "nome_completo_valor_dominio": "NORTE-AMERICANA (GUAM)",
      "descricao_conceito_valor_dominio": "NORTE-AMERICANA (GUAM) GU"
    },
    {
      "codigo_valor_dominio": 787,
      "codigo_referencia_valor_dominio": "MP",
      "nome_resumido_valor_dominio": "NORTE-AMERICANA (MP)",
      "nome_completo_valor_dominio": "NORTE-AMERICANA (ILHAS MARIANA)",
      "descricao_conceito_valor_dominio": "NORTE-AMERICANA (ILHAS MARIANA) MP"
    },
    {
      "codigo_valor_dominio": 788,
      "codigo_referencia_valor_dominio": "US",
      "nome_resumido_valor_dominio": "NORTE-AMERICANA (US)",
      "nome_completo_valor_dominio": "NORTE-AMERICANA (ESTADOS UNIDOS DA AMERICA)",
      "descricao_conceito_valor_dominio": "NORTE-AMERICANA (ESTADOS UNIDOS DA AMERICA) US"
    },
    {
      "codigo_valor_dominio": 789,
      "codigo_referencia_valor_dominio": "VI",
      "nome_resumido_valor_dominio": "NORTE-AMERICANA (VI)",
      "nome_completo_valor_dominio": "NORTE-AMERICANA (ILHAS VIRGENS)",
      "descricao_conceito_valor_dominio": "NORTE-AMERICANA (ILHAS VIRGENS) VI"
    },
    {
      "codigo_valor_dominio": 790,
      "codigo_referencia_valor_dominio": "KP",
      "nome_resumido_valor_dominio": "NORTE-COREANA",
      "nome_completo_valor_dominio": "NORTE-COREANA",
      "descricao_conceito_valor_dominio": "NORTE-COREANA KP"
    },
    {
      "codigo_valor_dominio": 791,
      "codigo_referencia_valor_dominio": "NO",
      "nome_resumido_valor_dominio": "NORUEGUESA",
      "nome_completo_valor_dominio": "NORUEGUESA",
      "descricao_conceito_valor_dominio": "NORUEGUESA NO"
    },
    {
      "codigo_valor_dominio": 792,
      "codigo_referencia_valor_dominio": "OM",
      "nome_resumido_valor_dominio": "OMANIANA",
      "nome_completo_valor_dominio": "OMANIANA",
      "descricao_conceito_valor_dominio": "OMANIANA OM"
    },
    {
      "codigo_valor_dominio": 793,
      "codigo_referencia_valor_dominio": "PW",
      "nome_resumido_valor_dominio": "PALAUENSE",
      "nome_completo_valor_dominio": "PALAUENSE",
      "descricao_conceito_valor_dominio": "PALAUENSE PW"
    },
    {
      "codigo_valor_dominio": 794,
      "codigo_referencia_valor_dominio": "PA",
      "nome_resumido_valor_dominio": "PANAMENHA",
      "nome_completo_valor_dominio": "PANAMENHA",
      "descricao_conceito_valor_dominio": "PANAMENHA PA"
    },
    {
      "codigo_valor_dominio": 795,
      "codigo_referencia_valor_dominio": "PG",
      "nome_resumido_valor_dominio": "PAPASIANA",
      "nome_completo_valor_dominio": "PAPASIANA",
      "descricao_conceito_valor_dominio": "PAPASIANA PG"
    },
    {
      "codigo_valor_dominio": 796,
      "codigo_referencia_valor_dominio": "PK",
      "nome_resumido_valor_dominio": "PAQUISTANESA",
      "nome_completo_valor_dominio": "PAQUISTANESA",
      "descricao_conceito_valor_dominio": "PAQUISTANESA PK"
    },
    {
      "codigo_valor_dominio": 797,
      "codigo_referencia_valor_dominio": "PY",
      "nome_resumido_valor_dominio": "PARAGUAIA",
      "nome_completo_valor_dominio": "PARAGUAIA",
      "descricao_conceito_valor_dominio": "PARAGUAIA PY"
    },
    {
      "codigo_valor_dominio": 798,
      "codigo_referencia_valor_dominio": "PE",
      "nome_resumido_valor_dominio": "PERUANA",
      "nome_completo_valor_dominio": "PERUANA",
      "descricao_conceito_valor_dominio": "PERUANA PE"
    },
    {
      "codigo_valor_dominio": 799,
      "codigo_referencia_valor_dominio": "PF",
      "nome_resumido_valor_dominio": "POLINESIA",
      "nome_completo_valor_dominio": "POLINESIA",
      "descricao_conceito_valor_dominio": "POLINESIA PF"
    },
    {
      "codigo_valor_dominio": 800,
      "codigo_referencia_valor_dominio": "PL",
      "nome_resumido_valor_dominio": "POLONESA",
      "nome_completo_valor_dominio": "POLONESA",
      "descricao_conceito_valor_dominio": "POLONESA PL"
    },
    {
      "codigo_valor_dominio": 801,
      "codigo_referencia_valor_dominio": "PR",
      "nome_resumido_valor_dominio": "PORTO-RIQUENHA",
      "nome_completo_valor_dominio": "PORTO-RIQUENHA",
      "descricao_conceito_valor_dominio": "PORTO-RIQUENHA PR"
    },
    {
      "codigo_valor_dominio": 802,
      "codigo_referencia_valor_dominio": "MO",
      "nome_resumido_valor_dominio": "PORTUGUESA / CHINESA (MO)",
      "nome_completo_valor_dominio": "PORTUGUESA / CHINESA (MACAO)",
      "descricao_conceito_valor_dominio": "PORTUGUESA / CHINESA (MACAO) MO"
    },
    {
      "codigo_valor_dominio": 804,
      "codigo_referencia_valor_dominio": "KE",
      "nome_resumido_valor_dominio": "QUENIANA",
      "nome_completo_valor_dominio": "QUENIANA",
      "descricao_conceito_valor_dominio": "QUENIANA KE"
    },
    {
      "codigo_valor_dominio": 805,
      "codigo_referencia_valor_dominio": "KG",
      "nome_resumido_valor_dominio": "QUIRGISTANESA",
      "nome_completo_valor_dominio": "QUIRGISTANESA",
      "descricao_conceito_valor_dominio": "QUIRGISTANESA KG"
    },
    {
      "codigo_valor_dominio": 806,
      "codigo_referencia_valor_dominio": "RO",
      "nome_resumido_valor_dominio": "ROMENA",
      "nome_completo_valor_dominio": "ROMENA",
      "descricao_conceito_valor_dominio": "ROMENA RO"
    },
    {
      "codigo_valor_dominio": 807,
      "codigo_referencia_valor_dominio": "RW",
      "nome_resumido_valor_dominio": "RUANDENSA",
      "nome_completo_valor_dominio": "RUANDENSA",
      "descricao_conceito_valor_dominio": "RUANDENSA RW"
    },
    {
      "codigo_valor_dominio": 808,
      "codigo_referencia_valor_dominio": "RU",
      "nome_resumido_valor_dominio": "RUSSA",
      "nome_completo_valor_dominio": "RUSSA",
      "descricao_conceito_valor_dominio": "RUSSA RU"
    },
    {
      "codigo_valor_dominio": 809,
      "codigo_referencia_valor_dominio": "AS",
      "nome_resumido_valor_dominio": "NORTE-AMERICANA (AS)",
      "nome_completo_valor_dominio": "NORTE-AMERICANA (SAMOA AMERICANA)",
      "descricao_conceito_valor_dominio": "NORTE-AMERICANA (SAMOA AMERICANA)"
    },
    {
      "codigo_valor_dominio": 811,
      "codigo_referencia_valor_dominio": "SV",
      "nome_resumido_valor_dominio": "SALVADORENHA",
      "nome_completo_valor_dominio": "SALVADORENHA",
      "descricao_conceito_valor_dominio": "SALVADORENHA SV"
    },
    {
      "codigo_valor_dominio": 812,
      "codigo_referencia_valor_dominio": "SM",
      "nome_resumido_valor_dominio": "SAMARINENSE",
      "nome_completo_valor_dominio": "SAMARINENSE",
      "descricao_conceito_valor_dominio": "SAMARINENSE SM"
    },
    {
      "codigo_valor_dominio": 813,
      "codigo_referencia_valor_dominio": "WS",
      "nome_resumido_valor_dominio": "SAMOANA",
      "nome_completo_valor_dominio": "SAMOANA",
      "descricao_conceito_valor_dominio": "SAMOANA WS"
    },
    {
      "codigo_valor_dominio": 814,
      "codigo_referencia_valor_dominio": "LC",
      "nome_resumido_valor_dominio": "SANTALUCIENSE",
      "nome_completo_valor_dominio": "SANTALUCIENSE",
      "descricao_conceito_valor_dominio": "SANTALUCIENSE LC"
    },
    {
      "codigo_valor_dominio": 815,
      "codigo_referencia_valor_dominio": "ST",
      "nome_resumido_valor_dominio": "SAO-TOMEENSE",
      "nome_completo_valor_dominio": "SAO-TOMEENSE",
      "descricao_conceito_valor_dominio": "SAO-TOMEENSE ST"
    },
    {
      "codigo_valor_dominio": 816,
      "codigo_referencia_valor_dominio": "VC",
      "nome_resumido_valor_dominio": "SAO-VICENTINA",
      "nome_completo_valor_dominio": "SAO-VICENTINA",
      "descricao_conceito_valor_dominio": "SAO-VICENTINA VC"
    },
    {
      "codigo_valor_dominio": 817,
      "codigo_referencia_valor_dominio": "SA",
      "nome_resumido_valor_dominio": "SAUDITA",
      "nome_completo_valor_dominio": "SAUDITA",
      "descricao_conceito_valor_dominio": "SAUDITA SA"
    },
    {
      "codigo_valor_dominio": 818,
      "codigo_referencia_valor_dominio": "SC",
      "nome_resumido_valor_dominio": "SEICHELENSE",
      "nome_completo_valor_dominio": "SEICHELENSE",
      "descricao_conceito_valor_dominio": "SEICHELENSE SC"
    },
    {
      "codigo_valor_dominio": 819,
      "codigo_referencia_valor_dominio": "SN",
      "nome_resumido_valor_dominio": "SENEGALESA",
      "nome_completo_valor_dominio": "SENEGALESA",
      "descricao_conceito_valor_dominio": "SENEGALESA SN"
    },
    {
      "codigo_valor_dominio": 820,
      "codigo_referencia_valor_dominio": "SL",
      "nome_resumido_valor_dominio": "SERRA-LEONESA",
      "nome_completo_valor_dominio": "SERRA-LEONESA",
      "descricao_conceito_valor_dominio": "SERRA-LEONESA SL"
    },
    {
      "codigo_valor_dominio": 821,
      "codigo_referencia_valor_dominio": "RS",
      "nome_resumido_valor_dominio": "SERVIA",
      "nome_completo_valor_dominio": "SERVIA",
      "descricao_conceito_valor_dominio": "SERVIA RS"
    },
    {
      "codigo_valor_dominio": 822,
      "codigo_referencia_valor_dominio": "SY",
      "nome_resumido_valor_dominio": "SIRIA",
      "nome_completo_valor_dominio": "SIRIA",
      "descricao_conceito_valor_dominio": "SIRIA SY"
    },
    {
      "codigo_valor_dominio": 823,
      "codigo_referencia_valor_dominio": "SO",
      "nome_resumido_valor_dominio": "SOMALIANA",
      "nome_completo_valor_dominio": "SOMALIANA",
      "descricao_conceito_valor_dominio": "SOMALIANA SO"
    },
    {
      "codigo_valor_dominio": 824,
      "codigo_referencia_valor_dominio": "SZ",
      "nome_resumido_valor_dominio": "SUAZILANDESA",
      "nome_completo_valor_dominio": "SUAZILANDESA",
      "descricao_conceito_valor_dominio": "SUAZILANDESA SZ"
    },
    {
      "codigo_valor_dominio": 825,
      "codigo_referencia_valor_dominio": "SD",
      "nome_resumido_valor_dominio": "SUDANESA",
      "nome_completo_valor_dominio": "SUDANESA",
      "descricao_conceito_valor_dominio": "SUDANESA SD"
    },
    {
      "codigo_valor_dominio": 826,
      "codigo_referencia_valor_dominio": "SE",
      "nome_resumido_valor_dominio": "SUECA",
      "nome_completo_valor_dominio": "SUECA",
      "descricao_conceito_valor_dominio": "SUECA SE"
    },
    {
      "codigo_valor_dominio": 827,
      "codigo_referencia_valor_dominio": "CH",
      "nome_resumido_valor_dominio": "SUICA",
      "nome_completo_valor_dominio": "SUICA",
      "descricao_conceito_valor_dominio": "SUICA CH"
    },
    {
      "codigo_valor_dominio": 828,
      "codigo_referencia_valor_dominio": "ZA",
      "nome_resumido_valor_dominio": "SUL-AFRICANA",
      "nome_completo_valor_dominio": "SUL-AFRICANA",
      "descricao_conceito_valor_dominio": "SUL-AFRICANA ZA"
    },
    {
      "codigo_valor_dominio": 829,
      "codigo_referencia_valor_dominio": "KR",
      "nome_resumido_valor_dominio": "SUL-COREANA",
      "nome_completo_valor_dominio": "SUL-COREANA",
      "descricao_conceito_valor_dominio": "SUL-COREANA KR"
    },
    {
      "codigo_valor_dominio": 830,
      "codigo_referencia_valor_dominio": "SS",
      "nome_resumido_valor_dominio": "SUL-SUDANESA",
      "nome_completo_valor_dominio": "SUL-SUDANESA",
      "descricao_conceito_valor_dominio": "SUL-SUDANESA SS"
    },
    {
      "codigo_valor_dominio": 831,
      "codigo_referencia_valor_dominio": "SR",
      "nome_resumido_valor_dominio": "SURINAMESA",
      "nome_completo_valor_dominio": "SURINAMESA",
      "descricao_conceito_valor_dominio": "SURINAMESA SR"
    },
    {
      "codigo_valor_dominio": 832,
      "codigo_referencia_valor_dominio": "TJ",
      "nome_resumido_valor_dominio": "TADJIQUE",
      "nome_completo_valor_dominio": "TADJIQUE",
      "descricao_conceito_valor_dominio": "TADJIQUE TJ"
    },
    {
      "codigo_valor_dominio": 833,
      "codigo_referencia_valor_dominio": "TH",
      "nome_resumido_valor_dominio": "TAILANSESA",
      "nome_completo_valor_dominio": "TAILANSESA",
      "descricao_conceito_valor_dominio": "TAILANSESA TH"
    },
    {
      "codigo_valor_dominio": 834,
      "codigo_referencia_valor_dominio": "TW",
      "nome_resumido_valor_dominio": "TAIWANESA",
      "nome_completo_valor_dominio": "TAIWANESA",
      "descricao_conceito_valor_dominio": "TAIWANESA TW"
    },
    {
      "codigo_valor_dominio": 835,
      "codigo_referencia_valor_dominio": "TZ",
      "nome_resumido_valor_dominio": "TANZANIANA",
      "nome_completo_valor_dominio": "TANZANIANA",
      "descricao_conceito_valor_dominio": "TANZANIANA TZ"
    },
    {
      "codigo_valor_dominio": 836,
      "codigo_referencia_valor_dominio": "CS",
      "nome_resumido_valor_dominio": "TCHECA",
      "nome_completo_valor_dominio": "TCHECA",
      "descricao_conceito_valor_dominio": "TCHECA CS"
    },
    {
      "codigo_valor_dominio": 837,
      "codigo_referencia_valor_dominio": "CZ",
      "nome_resumido_valor_dominio": "THECA",
      "nome_completo_valor_dominio": "THECA",
      "descricao_conceito_valor_dominio": "THECA CZ"
    },
    {
      "codigo_valor_dominio": 838,
      "codigo_referencia_valor_dominio": "TG",
      "nome_resumido_valor_dominio": "TOGOLESA",
      "nome_completo_valor_dominio": "TOGOLESA",
      "descricao_conceito_valor_dominio": "TOGOLESA TG"
    },
    {
      "codigo_valor_dominio": 839,
      "codigo_referencia_valor_dominio": "TO",
      "nome_resumido_valor_dominio": "TONGANESA",
      "nome_completo_valor_dominio": "TONGANESA",
      "descricao_conceito_valor_dominio": "TONGANESA TO"
    },
    {
      "codigo_valor_dominio": 840,
      "codigo_referencia_valor_dominio": "TT",
      "nome_resumido_valor_dominio": "TRINITARIA-TOBAGUENSE",
      "nome_completo_valor_dominio": "TRINITARIA-TOBAGUENSE",
      "descricao_conceito_valor_dominio": "TRINITARIA-TOBAGUENSE TT"
    },
    {
      "codigo_valor_dominio": 841,
      "codigo_referencia_valor_dominio": "TN",
      "nome_resumido_valor_dominio": "TUNISIANA",
      "nome_completo_valor_dominio": "TUNISIANA",
      "descricao_conceito_valor_dominio": "TUNISIANA TN"
    },
    {
      "codigo_valor_dominio": 842,
      "codigo_referencia_valor_dominio": "TR",
      "nome_resumido_valor_dominio": "TURCA",
      "nome_completo_valor_dominio": "TURCA",
      "descricao_conceito_valor_dominio": "TURCA TR"
    },
    {
      "codigo_valor_dominio": 843,
      "codigo_referencia_valor_dominio": "TM",
      "nome_resumido_valor_dominio": "TURQUISTANESA",
      "nome_completo_valor_dominio": "TURQUISTANESA",
      "descricao_conceito_valor_dominio": "TURQUISTANESA TM"
    },
    {
      "codigo_valor_dominio": 844,
      "codigo_referencia_valor_dominio": "TV",
      "nome_resumido_valor_dominio": "TUVALUANA",
      "nome_completo_valor_dominio": "TUVALUANA",
      "descricao_conceito_valor_dominio": "TUVALUANA TV"
    },
    {
      "codigo_valor_dominio": 845,
      "codigo_referencia_valor_dominio": "UA",
      "nome_resumido_valor_dominio": "UCRANIANA",
      "nome_completo_valor_dominio": "UCRANIANA",
      "descricao_conceito_valor_dominio": "UCRANIANA UA"
    },
    {
      "codigo_valor_dominio": 846,
      "codigo_referencia_valor_dominio": "UG",
      "nome_resumido_valor_dominio": "UGANDESA",
      "nome_completo_valor_dominio": "UGANDESA",
      "descricao_conceito_valor_dominio": "UGANDESA UG"
    },
    {
      "codigo_valor_dominio": 847,
      "codigo_referencia_valor_dominio": "UY",
      "nome_resumido_valor_dominio": "URUGUAIA",
      "nome_completo_valor_dominio": "URUGUAIA",
      "descricao_conceito_valor_dominio": "URUGUAIA UY"
    },
    {
      "codigo_valor_dominio": 848,
      "codigo_referencia_valor_dominio": "UZ",
      "nome_resumido_valor_dominio": "USBEQUISTANESA",
      "nome_completo_valor_dominio": "USBEQUISTANESA",
      "descricao_conceito_valor_dominio": "USBEQUISTANESA UZ"
    },
    {
      "codigo_valor_dominio": 849,
      "codigo_referencia_valor_dominio": "VU",
      "nome_resumido_valor_dominio": "VANUATESA",
      "nome_completo_valor_dominio": "VANUATESA",
      "descricao_conceito_valor_dominio": "VANUATESA VU"
    },
    {
      "codigo_valor_dominio": 850,
      "codigo_referencia_valor_dominio": "VA",
      "nome_resumido_valor_dominio": "VATICANA",
      "nome_completo_valor_dominio": "VATICANA",
      "descricao_conceito_valor_dominio": "VATICANA VA"
    },
    {
      "codigo_valor_dominio": 851,
      "codigo_referencia_valor_dominio": "VE",
      "nome_resumido_valor_dominio": "VENEZUELANA",
      "nome_completo_valor_dominio": "VENEZUELANA",
      "descricao_conceito_valor_dominio": "VENEZUELANA VE"
    },
    {
      "codigo_valor_dominio": 852,
      "codigo_referencia_valor_dominio": "VN",
      "nome_resumido_valor_dominio": "VIATINAMITA",
      "nome_completo_valor_dominio": "VIATINAMITA",
      "descricao_conceito_valor_dominio": "VIATINAMITA VN"
    },
    {
      "codigo_valor_dominio": 853,
      "codigo_referencia_valor_dominio": "ZM",
      "nome_resumido_valor_dominio": "ZAMBIANA",
      "nome_completo_valor_dominio": "ZAMBIANA",
      "descricao_conceito_valor_dominio": "ZAMBIANA ZM"
    },
    {
      "codigo_valor_dominio": 854,
      "codigo_referencia_valor_dominio": "ZW",
      "nome_resumido_valor_dominio": "ZIMBABUENSE",
      "nome_completo_valor_dominio": "ZIMBABUENSE",
      "descricao_conceito_valor_dominio": "ZIMBABUENSE ZW"
    },
    {
      "codigo_valor_dominio": 6587,
      "codigo_referencia_valor_dominio": "AN",
      "nome_resumido_valor_dominio": "ANTILHANA",
      "nome_completo_valor_dominio": "ANTILHANA",
      "descricao_conceito_valor_dominio": "ANTILHANA"
    },
    {
      "codigo_valor_dominio": 9716,
      "codigo_referencia_valor_dominio": "PT",
      "nome_resumido_valor_dominio": "PORTUGUESA",
      "nome_completo_valor_dominio": "PORTUGUESA",
      "descricao_conceito_valor_dominio": "PORTUGUESA"
    },
    {
      "codigo_valor_dominio": 9717,
      "codigo_referencia_valor_dominio": "SB",
      "nome_resumido_valor_dominio": "SALOMONICA",
      "nome_completo_valor_dominio": "SALOMONICA",
      "descricao_conceito_valor_dominio": "SALOMONICA"
    },
    {
      "codigo_valor_dominio": 9718,
      "codigo_referencia_valor_dominio": "TL",
      "nome_resumido_valor_dominio": "LESTE-TIMORENSE",
      "nome_completo_valor_dominio": "LESTE-TIMORENSE",
      "descricao_conceito_valor_dominio": "LESTE-TIMORENSE"
    }
  ]
}